import { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { ModalDeleteConfirm } from "@/components";
import { useLoadingStore } from "@/store/loadingStore";
import { useSearchParams } from "react-router-dom";
import { useShopStore } from "@/store/shopStore";
import { toastError, toastSuccess } from "@/utils/toastify";
import { DEFAULT_ERROR_MESSAGE, DEFAULT_SUCCESS_MESSAGE } from "@/types";
import { useCompanyStore } from "@/store/companyStore";
import { KEYS_SEARCH_PARAMS } from "./CompanyDetail";
import { cn } from "@/utils";


export const DeleteStore = ({
  id,
  disabled = false,
}: {
  id: number;
  disabled?: boolean;
  resetSearch?: () => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);

  const { deleteStore } = useShopStore();
  const { setLoading } = useLoadingStore();
  const { fetchMyStores, company } = useCompanyStore();

  const sParams = Object.fromEntries([...searchParams]);
  const companyId = company?.id;

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const resp = await deleteStore(id);

      if (companyId) {
        const currentPage = +sParams?.[KEYS_SEARCH_PARAMS.PAGE_STORE] || 1;
        const list = await fetchMyStores({
          page: currentPage,
          s: sParams?.[KEYS_SEARCH_PARAMS.SEARCH_STORE] || "",
        });
        if (
          list.data?.length < 1 &&
          currentPage > 1
        ) {
          // Delete the last record, go to prev page
          await fetchMyStores({
            page: +sParams?.[KEYS_SEARCH_PARAMS.PAGE_STORE] - 1, // min page = 1;
            s: sParams?.[KEYS_SEARCH_PARAMS.SEARCH_STORE] || "",
          });
          setSearchParams(
            {
              ...sParams,
              [KEYS_SEARCH_PARAMS.PAGE_STORE]: (currentPage - 1).toString(),
            },
            { replace: true },
          );
        }
      }
      toastSuccess(resp.message || DEFAULT_SUCCESS_MESSAGE);
    } catch (error: any) {
      toastError(error?.message || DEFAULT_ERROR_MESSAGE);
    }
    closeModal();
    setLoading(false);
  };

  return (
    <>
      <button onClick={openModal} disabled={disabled}>
        <FaTrash
          className={cn(
            "w-4 h-4 text-grey-600/80 hover:text-red-600 cursor-pointer",
            disabled
              ? "opacity-80 !cursor-not-allowed hover:!text-grey-600/80"
              : "",
          )}
        />
      </button>
      <ModalDeleteConfirm
        open={open}
        setOpen={setOpen}
        onDelete={handleDelete}
        onCancel={closeModal}
      />
    </>
  );
};
